import { ts } from '_core';

import { getName, validate } from './helpers';
import { DraftParams, INTERACTION_PARAMS } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.RISK_MODEL_BIAS_STATISTIC,
    title: 'Bias Statistic',
    helpLabel: 'lmqd6kgk',
    form: true,
    defaultParams: { weights: 'minimum_volatility', market_neutral: false } as DraftParams,
    // For old version of the widget (before it needed windows)
    interactionParams: Object.values(INTERACTION_PARAMS),
    neededFiles: ['risk_model_bias_statistic'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.RISK_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_RISK_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.STATISTICAL_RISK_MODEL,
    ],

    validate,
    getName,
  },
] satisfies ts.types.analysis.WidgetConfig[];
